import { getDashboardTutorialStatus, updateDashboardTutorialStatus } from '../../services/dashboard.service';
import { UPDATE_DASHBOARD_TUT_STATUS, FETCH_DASHBOARD_TUT_STATUS_SUCCESS } from './dashboardType';

export const fetchDashboardTutStatus = () => async (dispatch) => {
  const response = await getDashboardTutorialStatus();
  if (response?.status) {
    dispatch({
      type: FETCH_DASHBOARD_TUT_STATUS_SUCCESS,
      payload: { data: response.data },
    });
  }
};

export const updateDashboardTutStatus = {
  updateLongPressTut: () => async (dispatch) => {
    const response = await updateDashboardTutorialStatus('hasSeenLongPressTuts');
    if (response?.status) {
      dispatch({
        type: UPDATE_DASHBOARD_TUT_STATUS,
        payload: { data: response.status, field: 'hasSeenLongPressTuts' },
      });
    }
  },
};
